import { createAction, createRequestTypes, FAILURE, REQUEST, SUCCESS } from 'utils/actionGenerator';

export const FETCH_ISSUES = createRequestTypes('FETCH_ISSUES');
export const SUBMIT_ISSUE = createRequestTypes('SUBMIT_ISSUE');

export const fetchIssues = {
  request: (params) => createAction(FETCH_ISSUES[REQUEST], { params }),
  success: (response, params) => createAction(FETCH_ISSUES[SUCCESS], { response, params }),
  failure: (response) => createAction(FETCH_ISSUES[FAILURE], { response }),
};

export const submitIssue = {
  request: (params) => createAction(SUBMIT_ISSUE[REQUEST], { params }),
  success: (response, params) => createAction(SUBMIT_ISSUE[SUCCESS], { response, ...params }),
  failure: (response) => createAction(SUBMIT_ISSUE[FAILURE], { response }),
};
